export const FRECUENCIAS_INGRESO = [
  { id: 'DIARIA', name: 'Diaria' },
  { id: 'SEMANAL', name: 'Semanal' },
  { id: 'QUINCENAL', name: 'Quincenal' },
  { id: 'MENSUAL', name: 'Mensual' },
  { id: 'BIMESTRAL', name: 'Bimestral' },
  { id: 'OTRA', name: 'Otra' }
];